module.exports = __webpack_public_path__ + "media/images/icons/filled/cloud-a67f635fa10bcf3dcf8b9a40b22ad689.svg";